import { render, staticRenderFns } from "./PaginationSearching.vue?vue&type=template&id=5f0e6f11&lang=pug"
import script from "./PaginationSearching.vue?vue&type=script&lang=js"
export * from "./PaginationSearching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0e6f11')) {
      api.createRecord('5f0e6f11', component.options)
    } else {
      api.reload('5f0e6f11', component.options)
    }
    module.hot.accept("./PaginationSearching.vue?vue&type=template&id=5f0e6f11&lang=pug", function () {
      api.rerender('5f0e6f11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/refactoring/PaginationSearching.vue"
export default component.exports